import React, { useEffect, useState } from 'react';
import withRequest from "../../../hoc/withRequest";
import queryString from 'query-string';
import {useHistory, withRouter, useLocation} from "react-router-dom";
import { useCredential, useList } from "../../../components/hooks";
import {ROUTES} from "../../../consts";
import {Alert, ErrorScreen, ModalAlert} from "../../../components/common";
import CredentialListDumb from "./CredentialListDumb";

const CredentialListSmart = (props) => {
  const { getContentList, content, error, isLoaded } = useList('credentials');
  const credential = useCredential();
  const [openModal, setOpenModal] = useState(false);
  const [credentialSelected, setCredentialSelected] = useState(null);
  const history = useHistory();
  const location = useLocation();
  let { search } = queryString.parse(props.location.search);

  const alerts = [
    { severity: 'success',  open: credential.success.post,    message: 'credentialList.components.alert.success', },
    { severity: 'success',  open: credential.success.delete,  message: 'credentialList.components.alert.deleteSuccess', },
    { severity: 'info',     open: credential.success.put,     message: 'credentialList.components.alert.putSuccess', },
    { severity: 'error',    open: credential.error.put,       message: 'credentialList.components.alert.error', },
    { severity: 'error',    open: credential.error.delete,    message: 'credentialList.components.alert.error', },
    { severity: 'error',    open: credential.error.post,      message: 'credentialList.components.alert.error', },
  ];

  const handleListPage = () => {
    const query = {}
    if (search) {
      query.search = search;
    }
    getContentList({ query });
  }

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.CREDENTIAL_LIST}`;
    if (data.search !== '') {
      routeToPush = `${routeToPush}?search=${data.search}`
    }
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  }

  const handleCleanUp = () => {
    credential.cleanUpMessage();
  }

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.CREDENTIAL_CREATE);
  };

  const handleEdit = (credential) => {
    handleCleanUp();
    history.push(`${ROUTES.CREDENTIAL_EDIT}/${credential.credential_id}`);
  };

  const handleView = (credential) => {
    handleCleanUp();
    history.push(`${ROUTES.CREDENTIAL_VIEW}/${credential.credential_id}`);
  };

  useEffect(() => {
    handleListPage(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if ( credential.success.get ||  credential.success.post ||  credential.success.put ||  credential.success.delete ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ credential.success.get,  credential.success.post,  credential.success.put,  credential.success.delete, ]);

  const handleDelete = () => {
    const { credential_id } = credentialSelected;
    const body = { credential_id }
    credential.deleteCredential({ body });
    setOpenModal(false);
  }

  const handleModalDelete = (credential) => {
    setCredentialSelected(credential);
    setOpenModal(true);
  };

  return (
    <>
      { error ? (
          <ErrorScreen />
        ) : (
        <CredentialListDumb
          handleSearch={handleSearch}
          searchValue={search}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          handleView={handleView}
          content={content}
          isLoaded={isLoaded}
        />
        )
      }

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => credential.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  )
}

export default withRequest(withRouter(CredentialListSmart));
